export default "__VITE_ASSET__48afd786__"